import { render } from "./NumberRangeComponent.vue?vue&type=template&id=d0e8bb98"
import script from "./NumberRangeComponent.vue?vue&type=script&lang=js"
export * from "./NumberRangeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__